import ProgressBar from "../basicComponents/progressBar";

function DepartmentProgress({ data, type }: any) {
  const total = data.reduce((sum: any, item: any) => sum + item.value, 0);

  return (
    <div
      style={{ padding: "15px", width: "100%" }}
      className="border rounded-lg border-[#AAAAAA]"
    >
      <h1 className="text-base text-center mb-4">{type}</h1>
      {data.map((item: any) => {
        const progress = Math.min(Math.round((item.value / total) * 100), 100);
        return (
          <div
            key={item.name}
            className="flex items-center justify-around md:mb-4 mb-1"
          >
            <span className="text-[12px] md:w-4/12 w-5/12">{item.name}</span>
            <div className="md:w-8/12 w-7/12">
              <ProgressBar progress={progress} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default DepartmentProgress;
